function _templateObject3() {
  var data = _taggedTemplateLiteral(["&& {display: none}"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["&& {display: none}"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { css } from 'styled-components';
import { themeConfig } from "../../../theme";
import { getBreakpoints, getMultipliedIndent, getMargin } from "../../../theme/selectors";
import { mediaQueryFunctionsList, mediaQueryFunctionsListWithLimits, getMinWidthMedia, getMaxWidthMedia } from "../../../theme/helpers";
import { boxMarginPropsDict, boxPaddingPropsDict } from "../types";
export var addPaddingStyle = function addPaddingStyle(propName, value, theme) {
  var indent = getMultipliedIndent(theme, value);
  return {
    px: css(["padding-left:", ";padding-right:", ";"], indent, indent),
    py: css(["padding-top:", ";padding-bottom:", ";"], indent, indent),
    pt: css(["padding-top:", ";"], indent),
    pr: css(["padding-right:", ";"], indent),
    pb: css(["padding-bottom:", ";"], indent),
    pl: css(["padding-left:", ";"], indent)
  }[propName];
};
export var addMarginStyle = function addMarginStyle(propName, value, theme) {
  var indent = getMargin(theme, value);
  return {
    mx: css(["margin-left:", ";margin-right:", ";"], indent, indent),
    my: css(["margin-top:", ";margin-bottom:", ";"], indent, indent),
    mt: css(["margin-top:", ";"], indent),
    mr: css(["margin-right:", ";"], indent),
    mb: css(["margin-bottom:", ";"], indent),
    ml: css(["margin-left:", ";"], indent)
  }[propName];
};
export var addBoxPlainStyle = function addBoxPlainStyle(propName, value, theme) {
  return value !== true && Object.keys(boxPaddingPropsDict).includes(propName) ? addPaddingStyle(propName, value, theme) : addMarginStyle(propName, value, theme);
};

var getIndentBoxPropsKeys = function getIndentBoxPropsKeys(props) {
  return Object.keys(props).filter(function (prop) {
    return [].concat(_toConsumableArray(Object.keys(boxMarginPropsDict)), _toConsumableArray(Object.keys(boxPaddingPropsDict))).includes(prop);
  });
};

export var addIndentStyles = function addIndentStyles(indentPropsKeys, mediaQueries) {
  return function (props) {
    var theme = props.theme;
    return indentPropsKeys.map(function (propName) {
      var prop = props[propName];

      if (_typeof(prop) === 'object') {
        return Object.keys(prop).filter(function (breakpoint) {
          return themeConfig.breakpointNames.includes(breakpoint);
        }).map(function (breakpoint) {
          var plainStyles = addBoxPlainStyle(propName, prop[breakpoint], theme);
          return mediaQueries[breakpoint](_templateObject(), plainStyles);
        });
      }

      return addBoxPlainStyle(propName, prop, theme);
    });
  };
};
export var createBoxIndentStyles = function createBoxIndentStyles(allProps) {
  var theme = allProps.theme;
  var filteredIndentPropsKeys = getIndentBoxPropsKeys(allProps);
  var breakpoints = getBreakpoints(theme);
  /* eslint-disable @typescript-eslint/no-explicit-any */

  var mediaQueries = mediaQueryFunctionsList(breakpoints);
  return addIndentStyles(filteredIndentPropsKeys, mediaQueries);
}; // hide props

var createHideStyles = function createHideStyles(propName) {
  return function (props) {
    var prop = props[propName];
    var theme = props.theme;
    var breakpoints = getBreakpoints(theme);
    /* eslint-disable @typescript-eslint/no-explicit-any */

    var limitedMediaQueries = mediaQueryFunctionsListWithLimits(breakpoints);
    var media = breakpoints[prop];
    var mediaQueryFunctions = {
      hide: limitedMediaQueries[prop],
      hideBefore: getMaxWidthMedia(media),
      hideAfter: getMinWidthMedia(media)
    };

    if (prop) {
      if (Array.isArray(prop)) {
        return prop.map(function (breakpoint) {
          return limitedMediaQueries[breakpoint](_templateObject2());
        });
      }

      if (themeConfig.breakpointNames.includes(prop)) {
        return mediaQueryFunctions[propName](_templateObject3());
      }
    }
  };
};

var addHideStyle = createHideStyles('hide');
var addHideBeforeStyle = createHideStyles('hideBefore');
var addHideAfterStyle = createHideStyles('hideAfter');
export var addHideStyles = function addHideStyles() {
  return css(["", " ", " ", ""], addHideStyle, addHideBeforeStyle, addHideAfterStyle);
};